import React, { ReactNode } from "react";
import { useIsSmallScreen } from "../../App";
import { Padding } from "../../shared-components/Padding";
import { TEXT_COLOR, TEXT_INDENT, TEXT_SIZE } from "../../tokens";

export const LegacyTextBlock: React.FC<{ children: ReactNode }> = (props) => {
    const { children } = props;

    const isSmallScreen = useIsSmallScreen();

    return (
        <Padding onlySides>
            <div
                style={{
                    paddingBottom: 8,
                    paddingTop: 8,
                    paddingLeft: isSmallScreen ? TEXT_INDENT / 2 : TEXT_INDENT,
                    paddingRight: isSmallScreen ? TEXT_INDENT / 2 : TEXT_INDENT,
                    fontSize: isSmallScreen ? TEXT_SIZE * 0.9 : TEXT_SIZE,
                    textAlign: "justify",
                    color: TEXT_COLOR,
                }}
                className="legacy-text-block"
            >
                {children}
            </div>
        </Padding>
    );
};
